export const API_URL = "https://pokeapi.co/api/v2/pokemon";
export const DATA_PER_PAGE = 12;